<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>
              <div class="modal-body">
                <div class="row">
                  <label class="title" style="font-family: poppins"
                    >Edit Leadtime Settings
                  </label>
                  <!-- <label class="sub--title ml-1">* is a required field</label> -->
                </div>
                <form>
                  <div class="row row-space">
                    <div class="col-md-6">
                      <div class="input-group">
                        <label class="label" style="font-family: poppins"
                          >Tanggal<span style="color: red"></span
                        ></label>
                        <div class="input-group">
                          <flat-pickr
                            :config="rangePickr"
                            placeholder="Select Date"
                            v-model="form.tanggal"
                          ></flat-pickr>
                          <span
                            class="input-group-text bg-white"
                            style="
                              border-top-left-radius: 0;
                              border-bottom-left-radius: 0;
                              border: 0;
                              box-shadow: 0 0 6px #0000000f;
                              background-color: #ededed !important;
                            "
                          >
                            <i class="fas fa-calendar" style="color: black"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group">
                        <label class="label" style="font-family: poppins"
                          >Leadtime Range<span style="color: red"></span
                        ></label>
                        <div class="input-group">
                          <MultiSelect
                            v-model="form.value"
                            :options="value"
                            :allow-empty="false"
                            placeholder="Select Range"
                            class="tms-multiselect"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-5" style="text-align: end">
                      <button
                        type="button"
                        class="btn tms-btn-danger"
                        @click="$emit('closeModal')"
                        style="font-family: proxima-nova, sans-serif"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        class="btn tms-btn-primary"
                        @click="submitForm()"
                        style="font-family: proxima-nova, sans-serif"
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>
<script>
import moment from 'moment';
export default {
  props: ["data"],
  data() {
    return {
      rangePickr: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input elegant-flatpickr",
        minDate: moment().format('YYYY-MM-DD'),
      },
      value: [4, 5, 6, 7],
      form: {
        tanggal: "",
        value: "",
      },
    };
  },
  mounted() {
    this.form.tanggal = this.data.tanggal;
    this.form.value = this.data.value;
  },
  methods: {
    submitForm() {
      if (moment(this.form.tanggal).format('YYYY-MM-DD') === this.data.tanggal) delete this.form.tanggal;
      this.$http.put(`/api/settings/update/${this.data.id}`, this.form)
      .then(() => {
        this.$swal.fire({
            title: "Success!",
            icon: "success",
            text: "Successfully update Leadtime settings",
          });
        this.$emit('refreshData');
        this.$emit('closeModal');
      })
      .catch((err) => {
          this.$swal.fire({
            title: "Error!",
            icon: "error",
            text: err.response.data.message,
          });
        });
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1020;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/* MODAL STARTS */
.modal-body {
  margin: 0;
}

.modal-body .moduleLine {
  margin-bottom: 0vh;
}

.modal-body .moduleLine a {
  text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
  background-color: #e0e0e0;
  transition: background-color 0.7s ease;
  color: #212121;
  transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
  border: 1px solid #bdbdbd;
  border-radius: 20px;
  padding: 20px 0;
  color: black;
  margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
  font-size: 5vh;
}

h3.modalHeadline {
  margin: 0 0 20px 0;
  font-weight: bold;
  text-align: center;
}

/* MODAL ENDS */

/* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #909090;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding: 10px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
.title {
  font-size: 18px;
  color: #262626;
  /* margin-bottom: 40px; */
  text-align: center;
}

.sub--title {
  font-size: 10px;
  color: red;
  margin-bottom: 40px;
  text-align: center;
}

.center {
  text-align: center;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}

.outerBox {
  padding: 0 20px;
}
.innerBox {
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  padding: 5vw;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15);
}
.paddingInnerInnerBox {
  padding: 10px 15px;
}
.outerBoxPass {
  padding: 20px;
}
.innerBoxPass {
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  box-shadow: 10px 10px 20px #e0e0e0;
}
.innerBoxPass > .row:first-child {
  cursor: pointer;
}
.paddingInnerInnerBox p {
  margin: 0;
}
.subPartTitle {
  font-size: 110%;
  padding: 6px 12px;
  color: #757575;
}
.collapsed:hover {
  text-decoration: underline;
}
.collapseButton {
  color: black;
}

.input--style-4:disabled {
  background: #cfcfcf;
}

.modal-body {
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: auto;
}

.innerBox {
  padding: 0.8em 1.5em;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 2px 5px #e0e0e0;
}

.hoverable:hover {
  cursor: pointer;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
}

.custom-select select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fafafa;
  font-size: 16px;
  color: #666;
  transition: all 0.4s ease;
  cursor: pointer;
}

.custom-select select:focus {
  outline: none;
  border-color: #42b983;
  box-shadow: 0 0 5px rgba(66, 185, 131, 0.5);
}

.custom-select select::placeholder {
  color: #666;
}

.custom-select select:-ms-input-placeholder {
  color: #666;
}

/* Style the dropdown arrow */
.custom-select::after {
  content: "\f107"; /* FontAwesome chevron-down icon */
  font-family: FontAwesome;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

/* Style the select on hover */
.custom-select:hover select {
  border-color: #aaa;
}

/* Style the select when it's open */
.custom-select select.open {
  border-color: #42b983;
}

/* Style the select options */
.custom-select select option {
  padding: 10px;
  background-color: #fafafa;
  color: #666;
  font-size: 16px;
  transition: all 0.4s ease;
}

.custom-select select option:hover {
  background-color: #e0e0e0;
  color: #212121;
  transition: background-color 0.7s ease, color 0.7s ease;
}

.tms-btn-danger {
  background-color: #b1b1b1;
  color: #ffffff;
  margin-right: 20px;
}

.tms-btn-primary {
  background-color: #82b0ef;
  color: #ffffff;
}
</style>
